import VoucherIcon from 'assets/ver2/icons/voucher-icon-2.svg';
import { DESKTOP_MIN_WIDTH } from 'constants';
import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import styled from 'styled-components';

const FormProgressBar = ({ styles }) => {
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    setProgress(80);
  }, []);

  return (
    <FormProgressBarStyled style={styles}>
      <ProgressBarStyled striped now={progress} max={100} />
      <Image src={VoucherIcon} width={20} height={20} />
    </FormProgressBarStyled>
  );
};

const FormProgressBarStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  width: 100%;
  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 300px;
  }
`;

const ProgressBarStyled = styled(ProgressBar)`
  width: 100%;
  height: 12px;
  border-radius: 100px;
  background: #ececf0;
  & .progress-bar {
    background-color: var(--ds-c-yellow);
    border-radius: 100px;
  }
  & .progress-bar-striped {
    background-image: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
  }
`;

const Image = styled.img`
  width: 20px !important;
  height: 20px !important;
`;

export default FormProgressBar;
